import { FC } from 'react'
import { Button } from 'antd'
import { FormInstance } from 'antd/es/form'
import dayjs from 'dayjs'
import Development from '../../../../../components/development/development'
import FormValues, { ListItem } from '../types/form-values'
import { PackageCopies, Pallets, Windings } from '../../../../../types/api/shipment'

interface DevFillActionsProps {
    form: FormInstance<FormValues>
}

const pickRandom = <T,>(values: T[]): T => values[Math.floor(Math.random() * values.length)]

const DevFillActions: FC<DevFillActionsProps> = ({ form }) => {
    const autoFillForm = () => {
        const currentList = form.getFieldValue('list') || []
        if (currentList.length === 0) return

        const updatedList = currentList.map((item: ListItem, idx: number) => {
            const testItem: Partial<ListItem> = {
                designer: 'Баринова Екатерина',
                windingSchemeFace: Windings.A,
                windingSchemeTurn: Windings.B,
                quantityPerRoll: 1000,
                windingInfo: 'Краевые ролики по 200',
                package: 'Стретч',
                manualLabeling: false,
                clientLabel: false,
                packageCopies: PackageCopies.NotStrictly,
                pallet: Pallets.Euro,
                congreve: false,
                priming: false,
                comment: `Комментарий ${idx + 1}`,
                bushing: 45,
                printingOnGlueLayer: false,
                clientDeliveryDate: dayjs(),
            }

            const positions = item.positions || []
            const testPositions = positions.map((pos, pIdx) => ({
                ...pos,
                name: `Тестовая этикетка ${pIdx + 1}`,
                copies: 5000,
                comment: `Позиция ${pIdx + 1}`,
            }))

            return {
                ...item,
                ...testItem,
                positions: testPositions,
            }
        })

        form.setFieldsValue({ list: updatedList })
    }

    const autoFillRadioRandom = () => {
        const currentList = form.getFieldValue('list') || []
        if (currentList.length === 0) return

        const updatedList = currentList.map((item: ListItem) => {
            const positions = item.positions || []
            const updatedPositions = positions.map(pos => {
                const comment = (pos.comment || '').trim()
                const name = (pos.name || '').trim()
                const nextName = comment ? `${name} (${comment})`.trim() : name

                return {
                    ...pos,
                    name: nextName,
                    comment: comment ? '' : pos.comment,
                }
            })

            return {
                ...item,
                windingSchemeFace: pickRandom(Object.values(Windings)),
                windingSchemeTurn: pickRandom([...Object.values(Windings), null]),
                bushing: pickRandom([40, 45, 76, 152]),
                printingOnGlueLayer: pickRandom([true, false]),
                package: pickRandom([
                    'Стретч',
                    'Стретч+гофро',
                    'Стретч+гофро+паллет',
                    'Стретч+паллет',
                    'Короб',
                ]),
                packageCopies: pickRandom([PackageCopies.Strictly, PackageCopies.NotStrictly]),
                windingInfo: pickRandom(['Строго', 'краевые ролики по 200', '']),
                manualLabeling: pickRandom([true, false]),
                clientLabel: pickRandom([true, false]),
                pallet: pickRandom([Pallets.Euro, Pallets.Any, Pallets.No]),
                congreve: pickRandom([true, false]),
                priming: pickRandom([true, false]),
                positions: updatedPositions,
                clientDeliveryDate: dayjs().add(pickRandom([4, 5, 6, 7]), 'day'),
            }
        })

        form.setFieldsValue({ list: updatedList })
    }

    return (
        <Development>
            <Button onClick={autoFillForm}>Заполнить тестовыми данными</Button>
            <Button onClick={autoFillRadioRandom}>Заполнить Radio Random</Button>
        </Development>
    )
}

export default DevFillActions
